export function GetObject<T> (key : string) : T | false {
    let content = localStorage.getItem(key);

    if(content)
        return JSON.parse(content);
    else return false;
}

export function SetObject<T> (key : string, obj: T) {
    return localStorage.setItem(key, JSON.stringify(obj));
}

export const RemoveObject = (key: string) => {
    return localStorage.removeItem(key);
}